exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-Button--ghost {\n  background-color: transparent;\n  color: #005091;\n  border: 2px solid #005091; }\n  .hover-active .a-Button--ghost:focus {\n    color: #005091;\n    background-color: transparent; }\n  .hover-active .a-Button--ghost:hover {\n    color: #fff;\n    background-color: #00345e;\n    border-color: #00345e; }\n", ""]);

// exports
